<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <v-col xs12>
        <v-progress-linear
          indeterminate
          color="primary"
          class="mt-4"
          v-if="loading"
        ></v-progress-linear>
        <v-card v-if="!loading && isAdmin">
          <v-card-title primary-title>Company Logo</v-card-title>
          <v-card-text>
            <p>
              Update your company logo. This logo will show in the pdf
              downloads.
            </p>
            <img :src="base64" style="max-width: 250px" /><br />
            <p>*Max file size is 1MB.</p>
            <v-btn color="primary" @click="openDialog">Upload Logo</v-btn>
          </v-card-text>
        </v-card>
        <v-card v-if="!loading && isAdmin" class="mt-4">
          <v-card-title primary-title>Users</v-card-title>
          <v-card-text>
            <p>
              Manage users. You can disable a users account by changing the
              setting to disabled (from active).
            </p>
            <v-data-table :headers="headers" :items="users" :search="search">
              <template v-slot:item.name="{ item }">
                {{ item.firstName }} {{ item.lastName }}
              </template>
              <template v-slot:item.edit="{ item }">
                <v-switch
                  v-model="item.active"
                  inset
                  color="green"
                  @change="updateUser(item)"
                  :label="`${item.active ? 'active' : 'disabled'}`"
                ></v-switch>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
        <v-card v-if="!loading && !isAdmin">
          <v-card-title class="text-h5"> Profile </v-card-title>
          <v-card-text> Email: {{ this.user.email }} </v-card-text>
        </v-card>
      </v-col>
    </v-layout>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="text-h5"> Upload Company Logo </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="file"
            hint="Max Size 1MB"
            label="Company Logo"
            accept="image/png, image/jpeg"
            filled
            prepend-icon="mdi-camera"
            :show-size="1000"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false"> Cancel </v-btn>
          <v-btn color="primary" @click="onUpload" :disabled="!file">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snack = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import fb from "@/main";

export default {
  data() {
    return {
      isAdmin: false,
      loading: true,
      dialog: false,
      search: "",
      file: null,
      users: [],
      base64:
        "data:image/jpeg;base64,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",
      snack: false,
      snackColor: "",
      snackText: "",
      headers: [
        {
          text: "Name",
          align: "start",
          value: "name",
        },
        {
          text: "Email",
          align: "start",
          value: "email",
        },
        {
          text: "",
          align: "end",
          value: "edit",
          width: 150,
        },
      ],
    };
  },
  async created() {
    try {
      var isAdministrator = fb.functions.httpsCallable("isAdministrator");
      const { data: isAdmin } = await isAdministrator();
      this.isAdmin = isAdmin;
      if (isAdmin) {
        var getUsers = fb.functions.httpsCallable("getCompanyUsers");
        const { data: users } = await getUsers();
        this.users = users.filter((u) => {return u.email != this.user.email}).map((u) => {
          return { ...u, active: !u.disabled };
        });
      }
      this.loading = false;
    } catch (error) {
      this.$router.push("/");
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    onUpload: async function () {
      if (!this.file) {
        return;
      }

      try {
        // max size 1mb
        const maxAllowedSize = 1 * 1024 * 1024;
        if (this.file.size > maxAllowedSize) {
          alert("File is too large. Try again.");
          return;
        }
        const base64 = await this.getBase64(this.file);
        const domain = this.user.email.split("@")[1].toLowerCase();
        await fb.db.collection("companyInfo").doc(domain).set({ logo: base64 });
        await this.getLogo();
        this.dialog = false;
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Success uploading image.";
      } catch (e) {
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error uploading image.";
      }
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getLogo: async function () {
      const res = await fb.db
        .collection("companyInfo")
        .doc(this.user.domain)
        .get();
      if (res.exists) {
        const obj = res.data();
        if (obj.logo) {
          this.base64 = obj.logo;
        }
      }
    },
    async updateUser(user) {
      console.log(user);
      try {
        var updateUser = fb.functions.httpsCallable("updateCompanyUser");
        const data = await updateUser({ id: user.uid, active: user.active });
        if (data) {
          this.snack = true;
          this.snackColor = "success";
          this.snackText = "Successfully updated user.";
        }
      } catch (error) {
        console.log(error);
        this.snack = true;
        this.snackColor = "error";
        this.snackText = "Error updating user.";
      }
    },
  },
  mounted: async function () {
    this.getLogo();
  },
};
</script>
